import codePensList from 'data/codepen.json';
import { useEffect, useState } from "react";

export function useCodePens() {
    const [codePens, setCodePens] = useState([]);
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {
        try {
            setLoading(true);
            const codePenListSorted = codePensList.sort((a, b) => a.position - b.position)
            setCodePens(codePenListSorted.filter(codepen => {
                return codepen.visible
            }));
        } catch (error) {
            console.log(error)
            setError(error)
        } finally {
            setLoading(false)
        }
    }, [])

    return { codePens, loading, error };
}